module.exports = __webpack_public_path__ + "static/media/e_64k.d32824a6.mp3";